import { useEffect, useRef } from "react";
import { useMst } from "../../stores/main";
import "./DataSetter.scss";
import { observer } from "mobx-react-lite";
import { DynamicForm } from "@blings/dynamic-form";
import { cleanEmptyStringInValue } from "../../helpers/objects";
import BlingsTheme from "../../config/antdTheme";
import { isEqual } from "lodash";
import {
  cloneDynamicFormData,
  detectRenamedKey,
  transformDataWithRenamedKey,
} from "../../helpers/dynamicFormKeyRename";
import type { DynamicFormData } from "../../helpers/dynamicFormKeyRename";

type Props = {};
export const LiveControlSetter = observer((props: Props) => {
  const {
    platformStore,
    dynamicDataStore: {
      setCurrentLiveControlData,
      setCurrentLiveControlSchema,
      liveControlInitialSchema,
      liveControlCurrentData,
      liveControlCurrentSchema,
      updateModsWithRenamedKeys,
    },
  } = useMst();

  const submit = useRef<() => void>(() => {
    return;
  });
  const isFirstChange = useRef(true);
  const previousFormDataRef = useRef<DynamicFormData>(
    cloneDynamicFormData(liveControlCurrentData as DynamicFormData)
  );

  useEffect(() => {
    previousFormDataRef.current = cloneDynamicFormData(
      liveControlCurrentData as DynamicFormData
    );
  }, [liveControlCurrentData]);

  if (!platformStore.projectWorkspaceVersion)
    return <div className={"editor-wrapper"}></div>;

  return (
    <div style={{ height: "100%" }}>
      <div className={"editor-wrapper"}>
        <DynamicForm
          schemaType="control"
          themeConfig={BlingsTheme}
          key={`${liveControlInitialSchema}-LiveControl`}
          schema={JSON.parse(liveControlCurrentSchema || "{}")}
          formData={JSON.parse(JSON.stringify(liveControlCurrentData))}
          saveData={(data, schema) => {
            const cleanData = cleanEmptyStringInValue(data);
            platformStore.saveLiveControlSchema(schema, cleanData);
          }}
          submit={submit}
          editable={true}
          uiMode="tree"
          insertAt="start"
          uploadAssetToProject={platformStore.uploadAssetToProject}
          getAssetsUploadStatus={platformStore.getDynamicFormAssetsUploadStatus}
          onChange={(formData: DynamicFormData, schema) => {
            if (isFirstChange.current) {
              isFirstChange.current = false;
              if (isEqual(formData, previousFormDataRef.current)) {
                previousFormDataRef.current = cloneDynamicFormData(formData);
                return;
              }
            }

            const renamed = detectRenamedKey(
              previousFormDataRef.current,
              formData
            );

            if (renamed) {
              updateModsWithRenamedKeys(
                renamed.oldKey,
                renamed.newKey,
                "control"
              );
              const transformedData = transformDataWithRenamedKey(
                previousFormDataRef.current,
                renamed.oldKey,
                renamed.newKey
              );

              previousFormDataRef.current = cloneDynamicFormData(
                transformedData
              );
              setCurrentLiveControlData(transformedData);
              setCurrentLiveControlSchema(schema);
              return;
            }

            previousFormDataRef.current = cloneDynamicFormData(formData);
            setCurrentLiveControlData(formData);
            setCurrentLiveControlSchema(schema);
          }}
          readable={false}
          fieldDescription={{
            key: "A name for the data field",
            value:
              "Data value. Can be updated for all videos from Blings platform",
          }}
        />
      </div>
    </div>
  );
});
